import React, { memo, useRef, useState } from "react";
import Separator from "../../../../../core/components/Separator.tsx";
import { FiltroEmbarqueCompletoEnum } from "../../../../../models/FiltroEmbarqueCompleto.ts";
import IconButton from "../../../../../core/components/IconButton.tsx";
import Tag from "../../../../../core/data-display/Tag.tsx";
import "./data-entry-viagens.css";
import { useFiltro } from "../../../../../contexts/FiltroContext.tsx";
import { motion } from "framer-motion";
interface InputTagProps {
	title?: string;
	filtroKey: FiltroEmbarqueCompletoEnum;
	tags: string[];
	showBorder?: boolean;
}

function InputTag({
	title,
	filtroKey,
	tags = [],
	showBorder = true,
}: InputTagProps) {
	const { setFiltro } = useFiltro();
	const [inputValue, setInputValue] = useState("");
	const [isFocused, setIsFocused] = useState(false);
	const inputRef = useRef<HTMLInputElement>(null);

	const handleAddTag = () => {
		if (inputValue.trim() !== "") {
			const updatedTags = [...tags, inputValue.trim()];
			setFiltro(filtroKey, updatedTags);
			setInputValue("");
		}
	};

	const handleRemoveTag = (tagToRemove: string) => {
		const updatedTags = tags.filter((tag) => tag !== tagToRemove);
		setFiltro(filtroKey, updatedTags);
	};

	return (
		<div
			className="modal-filtros-viagens-input-container"
			style={{
				border: showBorder ? "1px solid #ccc" : "none",
			}}
		>
			<div className="modal-filtros-viagens-input-tag">
				{title && <p>{title}</p>}
				<Separator size="xs" />
				<motion.div
					transition={{ duration: 0.2, delay: 0.1 }}
					style={{
						border: isFocused ? "1px solid #2684ff" : "1px solid #fff",
						boxShadow: isFocused ? "0 0 5px rgba(0, 123, 255, 0.5)" : "none",
					}}
					className="modal-filtros-viagens-input-button"
				>
					<input
						type="text"
						ref={inputRef}
						className="select-field-input"
						onFocus={() => setIsFocused(true)}
						onBlur={() => setIsFocused(false)}
						value={inputValue}
						onChange={(e) => setInputValue(e.target.value)}
						onKeyDown={(e) => {
							if (e.key === "Enter") {
								e.preventDefault();
								handleAddTag();
							}
						}}
						placeholder="Digite e pressione Enter"
					/>
					<Separator size="xs" direction="horizontal" />
					<motion.div
						initial={{ rotate: 0 }}
						whileHover={{ rotate: 90 }}
						transition={{ duration: 0.2, ease: "easeInOut" }}
						className="select-field-chevron"
					>
						<IconButton
							icon="Plus"
							size="md"
							borderColor="#e0e0e0"
							theme="dark"
							backgroundColor="#FEFEFE"
							onClick={handleAddTag}
						/>
					</motion.div>
					<Separator size="xs" direction="horizontal" />
				</motion.div>
			</div>
			<Separator size="md" />
			<div className="modal-filtros-viagens-input-tag-list">
				{tags.map((tag, index) => (
					<Tag
						key={index}
						label={tag}
						size="md"
						icon="X"
						onClick={() => handleRemoveTag(tag)}
					/>
				))}
				{tags.length > 0 && <Separator size="md" />}
			</div>
		</div>
	);
}

export default memo(InputTag);
